import { baseVariables, toRem } from '@marriott/mi-ui-library';
import styled from 'styled-components';

export const StyledWalletFreeNightAwardsSection = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${toRem(16)};

  .wallet-free-night-awards-section__heading-row {
    display: flex;
    align-items: center;
    gap: ${toRem(8)};
  }

  .wallet-free-night-awards-section__heading {
    margin: 0;
    color: ${baseVariables.color['base10']};
    font-size: ${toRem(22)};
    font-weight: ${baseVariables.font.fontWeightMedium};
    line-height: 1.25;
  }

  .wallet-free-night-awards-section__count {
    min-width: ${toRem(24)};
    height: ${toRem(24)};
    border-radius: ${toRem(999)};
    background: ${baseVariables.color['base10']};
    color: #ffffff;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0 ${toRem(8)};
    font-size: ${toRem(12)};
    font-weight: ${baseVariables.font.fontWeightMedium};
    line-height: 1;
  }

  .wallet-free-night-awards-section__empty-state {
    border: ${toRem(1)} dashed ${baseVariables.color['neutral30']};
    border-radius: ${toRem(14)};
    background: transparent;
    padding: ${toRem(24)};
    display: flex;
    align-items: center;
    gap: ${toRem(16)};
  }

  .wallet-free-night-awards-section__empty-media {
    width: ${toRem(72)};
    height: ${toRem(52)};
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .wallet-free-night-awards-section__empty-image {
    width: 100%;
    height: 100%;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

  .wallet-free-night-awards-section__empty-text {
    display: flex;
    flex: 1 0 0;
    min-width: 0;
    flex-direction: column;
  }

  .wallet-free-night-awards-section__empty-message {
    color: ${baseVariables.color['neutral40']};
    margin: 0;
  }

  .wallet-free-night-awards-section__empty-cta {
    flex-shrink: 0;
    min-height: ${toRem(32)};
    display: inline-flex;
    align-items: center;
    font-size: ${toRem(13)};
    color: ${baseVariables.color['base10']};
    font-weight: ${baseVariables.font.fontWeightMedium};
    text-decoration: underline;
    text-underline-offset: ${toRem(3)};
  }

  .wallet-free-night-awards-section__description {
    font-size: ${toRem(14)};
    line-height: 1.5;
    color: ${baseVariables.color['base10']};
    margin: 0;
  }

  .wallet-free-night-awards-section__description-link {
    font-size: ${toRem(14)};
    color: ${baseVariables.color['base10']};
    text-decoration: underline;
    text-underline-offset: ${toRem(3)};
    margin-left: ${toRem(4)};
  }

  .wallet-free-night-awards-section__tiles {
    display: grid;
    grid-template-columns: 1fr;
    gap: ${toRem(16)};
  }

  @media ${baseVariables.mediaQuery.md} {
    .wallet-free-night-awards-section__tiles {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }

  @media screen and (max-width: ${toRem(767)}) {
    .wallet-free-night-awards-section__empty-state {
      flex-direction: column;
      align-items: flex-start;
      gap: ${toRem(12)};
      padding: ${toRem(16)};
    }
  }
`;
